import { render } from "./Navgater.vue?vue&type=template&id=1ad976c9&scoped=true&ts=true"
import script from "./Navgater.vue?vue&type=script&lang=ts"
export * from "./Navgater.vue?vue&type=script&lang=ts"

import "./Navgater.vue?vue&type=style&index=0&id=1ad976c9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad976c9"]])

export default __exports__